import { taggedTemplateLiteral as _taggedTemplateLiteral, objectWithoutProperties as _objectWithoutProperties } from '../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';

var _excluded = ["theme"];
var _templateObject, _templateObject2;
var SINGLE_COL_WIDTH = 8.3333;
var DEFAULT_SPACING = 0.5;
var BP_MAP = {
  lg: '$lg',
  md: '$md',
  sm: '$sm',
  xl: '$xl',
  xs: '$xs'
};
var getColGutter = function getColGutter(_ref) {
  var $container = _ref.$container;
  return $container ? DEFAULT_SPACING * 2 : DEFAULT_SPACING;
};
var getRowGutter = function getRowGutter() {
  return DEFAULT_SPACING;
};
var applyPadding = function applyPadding(_ref2) {
  var $container = _ref2.$container,
    $page = _ref2.$page;
  return $container || $page ? "0 ".concat(getColGutter({
    $container: $container,
    $page: $page
  }), "rem") : 'auto';
};
var applyMargin = "-".concat(DEFAULT_SPACING, "rem -").concat(DEFAULT_SPACING, "rem auto auto");
var applyGridWidth = function applyGridWidth(props) {
  return "calc(100% + ".concat(getColGutter(props), "rem)");
};
var GridStyles = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  align-items: stretch;\n  box-sizing: border-box;\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: row;\n  margin: ", ";\n  padding: ", ";\n  width: ", ";\n\n  --sb-grid-col-gutter: ", "rem;\n  --sb-grid-row-gutter: ", "rem;\n"])), applyMargin, applyPadding, applyGridWidth, getColGutter, getRowGutter);
var getWidths = function getWidths(_ref3) {
  var theme = _ref3.theme,
    breakpoints = _objectWithoutProperties(_ref3, _excluded);
  return Object.keys(theme.breakpoints).map(function (breakpoint) {
    var columns = breakpoints[BP_MAP[breakpoint]];
    if (!columns) return '';
    var width = columns * SINGLE_COL_WIDTH;
    return "".concat(theme.mqFrom(breakpoint), " {\n      flex-basis: ").concat(width, "%;\n      max-width: ").concat(width, "%;\n    }");
  });
};
var GridItemStyles = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  flex-basis: 100%;\n  flex-direction: row;\n  flex-grow: 0;\n  margin: 0;\n  max-width: 100%;\n  padding-top: var(--sb-grid-row-gutter);\n  padding-right: var(--sb-grid-col-gutter);\n\n  ", "\n"])), getWidths);

export { GridItemStyles, GridStyles };
//# sourceMappingURL=Grid.styles.js.map
